export const environment = {
  production: false,
  environmentName: 'staging',
  appVersion: '0.0.0-staging',
  suppressLocalSentry: true,
  sentryDsn:
    'https://8b205ac9f964d6e03e7bfbea28134a10@o4510041001885701.ingest.us.sentry.io/4510754351874048',
  port: 11000,
  domain: 'https://rhogicsomapi.gxstaging.net/api',
};
